import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { BsSearch } from 'react-icons/bs';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col, Spinner } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
import { DELETE_ELECTRICITY_SUPPLIER, FETCH_ELECTRICITY_SUPPLIER, GET_ELECTRICITY_SUPPLIER } from 'actions/electricitySupplier';
// import Pagination from 'components/general/Pagination';
import ReactPagination from 'components/general/ReactPagination';
import { Modal } from 'react-bootstrap';
import ElectricitySupplierForm from './ElectricitySupplierForm';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';

const ElectricitySupplierList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  // const [allElectricitySupplierData, setAllElectricitySupplierData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [electricitySupplierId, setElectricitySupplierId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });

  const page = useSelector((state) => state.electricitySupplier.page);
  const totalData = useSelector((state) => state.electricitySupplier.total);
  const limit = useSelector((state) => state.electricitySupplier.limit);
  const totalPages = useSelector((state) => state.electricitySupplier.totalPages);
  const electricitySuppliersList = useSelector((state) => state.electricitySupplier.electricitySuppliers);
  const isLoader = useSelector((state) => state.electricitySupplier.isLoading);

  const getElectricitySupplier = useCallback(
    (data = {}) => {
      if (searchText) {
        const electricitySupplierData = {
          ...data,
          search: searchText,
        };
        dispatch({ type: FETCH_ELECTRICITY_SUPPLIER.REQUEST, payload: electricitySupplierData });
      } else {
        dispatch({ type: FETCH_ELECTRICITY_SUPPLIER.REQUEST, payload: data });
      }
    },
    [searchText]
  );

  const getElectricitySupplierDetail = useCallback((id) => {
    dispatch({ type: GET_ELECTRICITY_SUPPLIER.REQUEST, payload: id });
  }, []);

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setElectricitySupplierId('');
  };

  const deleteElectricitySupplier = useCallback(
    () =>
      dispatch({
        type: DELETE_ELECTRICITY_SUPPLIER.REQUEST,
        payload: electricitySupplierId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getElectricitySupplier({ page: 1 });
          }
        },
      }),
    [electricitySupplierId]
  );

  useEffect(() => {
    getElectricitySupplier();
  }, []);

  const handleSearch = () => {
    getElectricitySupplier({});
  };
  // useEffect(() => {
  //   setAllElectricitySupplierData(
  //     _.filter(
  //       electricitySuppliersList,
  //       (item) => startsWith(_.get(item, 'name', ''), searchText) || startsWith(_.get(item, 'city.name', ''), searchText)
  //     )
  //   );
  // }, [searchText, electricitySuppliersList]);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getElectricitySupplier(data);
      }
    },
    [sortByItem]
  );

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getElectricitySupplier(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getElectricitySupplier(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handleCloseFormElectricitySupplier = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.electricitySupplier')} />
        <div className="page-content-wrapper scrollable">
          <div className="electricitySupplierList-page">
            <Card>
              <div className="electricitySupplierList-page-wrapper">
                <Row className="electricitySupplierList-search-box">
                  <Col xl={10} lg={9} md={8} className="electricitySupplierList-search-inputBox">
                    <SearchBox
                      value={searchText}
                      preIcon={<BsSearch />}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                    />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="electricitySupplierList-search-boxButton">
                    <Button
                      className="electricitySupplierList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      {t('button.addSupplier')}
                    </Button>
                  </Col>
                </Row>
                <div className="electricitySupplierList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span> {t('electricitySupplierForm.electricitySupplierName')}</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>{t('filters.country')}</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>{t('filters.state')}</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>{t('filters.city')}</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>{t('electricitySupplierForm.rateUnit')}</span>
                              <span className="ico" onClick={() => handleSorting('rate', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th className="action-col">
                            <div className="sorting">
                              <span>{t('electricitySupplierForm.action')}</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoader ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">{t('placeHolder.loading')}</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(electricitySuppliersList) ? (
                          <tr>
                            <td colSpan={6} className="border-0">
                              <div className="empty-data-block">{t('electricitySupplierForm.noData')}</div>
                            </td>
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(electricitySuppliersList, (item, key) => {
                            return (
                              <>
                                <tr key={`electricitySupplier-${key}`}>
                                  <td>{_.get(item, 'name', '')}</td>
                                  <td>{_.get(item, 'city.state.country.name', '')}</td>
                                  <td>{_.get(item, 'city.state.name', '')}</td>
                                  <td>{_.get(item, 'city.name', '')}</td>
                                  <td>{_.get(item, 'rate', '')}</td>
                                  <td>
                                    <span
                                      className="electricitySupplierList-table-editIcon"
                                      onClick={() => {
                                        setShowForm(true);
                                        getElectricitySupplierDetail(_.get(item, 'id', ''));
                                        setIsEdit(true);
                                      }}
                                    >
                                      <FiEdit2 title="Edit" />
                                    </span>
                                    <span
                                      className="electricitySupplierList-table-deleteIcon"
                                      onClick={() => {
                                        setShowDeleteModal(true);
                                        setElectricitySupplierId(_.get(item, 'id', ''));
                                      }}
                                    >
                                      <RiDeleteBinLine title="Delete" />
                                    </span>
                                  </td>
                                </tr>
                              </>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                    {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(electricitySuppliersList) && (
                      <ReactPagination
                        currentPage={page}
                        limit={limit}
                        total={totalData}
                        handlePageClick={(pageVal) => handlePageClick(pageVal)}
                        totalPages={totalPages}
                        marginPagesDisplayed={1}
                      />
                      // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered>
            <ElectricitySupplierForm onClose={handleCloseFormElectricitySupplier} isEdit={isEdit} onSuccess={getElectricitySupplier} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="electricitySupplier" onClose={handleCloseDeleteModel} onRemove={deleteElectricitySupplier} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};
export default ElectricitySupplierList;
